// Comprehensive amenities list shared across listing forms and property details
export const ALL_AMENITIES = [
  { id: 'WiFi',        label: 'WiFi',            emoji: '📶' },
  { id: 'Internet',    label: 'Internet',         emoji: '🌐' },
  { id: 'Kitchen',     label: 'Kitchen',          emoji: '🍳' },
  { id: 'Bathroom',    label: 'Bathroom',         emoji: '🚿' },
  { id: 'En-suite',    label: 'En-suite',         emoji: '🛁' },
  { id: 'Common Room', label: 'Common Room',      emoji: '🛋️' },
  { id: 'AC',          label: 'Air Conditioning', emoji: '❄️' },
  { id: 'Heating',     label: 'Heating',          emoji: '🔥' },
  { id: 'Laundry',     label: 'Laundry',          emoji: '🧺' },
  { id: 'Dishwasher',  label: 'Dishwasher',       emoji: '🍽️' },
  { id: 'Gym',         label: 'Gym',              emoji: '🏋️' },
  { id: 'Pool',        label: 'Swimming Pool',    emoji: '🏊' },
  { id: 'Parking',     label: 'Parking',          emoji: '🚗' },
  { id: 'Balcony',     label: 'Balcony',          emoji: '🌅' },
  { id: 'Courtyard',   label: 'Courtyard',        emoji: '🌳' },
  { id: 'Garden',      label: 'Garden',           emoji: '🌿' },
  { id: 'Security',    label: '24/7 Security',    emoji: '🔒' },
  { id: 'Fireplace',   label: 'Fireplace',        emoji: '🪵' },
  { id: 'Study Room',  label: 'Study Room',       emoji: '📚' },
  { id: 'Bike Storage',label: 'Bike Storage',     emoji: '🚲' },
  { id: 'Couples OK',  label: 'Couples Welcome',  emoji: '💑' },
  { id: 'Pets Allowed',label: 'Pets Allowed',     emoji: '🐾' },
];

// Duration pricing options with discounts
export const DURATION_OPTIONS = [
  { weeks: 12, label: '12 Weeks', subLabel: 'Min Stay',   discount: 0    },
  { weeks: 15, label: '15 Weeks', subLabel: 'Standard',   discount: 0    },
  { weeks: 20, label: '20 Weeks', subLabel: '3% off',     discount: 0.03 },
  { weeks: 40, label: '40 Weeks', subLabel: '7% off',     discount: 0.07 },
  { weeks: 52, label: '52 Weeks', subLabel: '12% off — Best', discount: 0.12 },
];

// Time slots every 30 min 9am–5pm
export const TIME_SLOTS_30MIN = [
  '9:00 AM','9:30 AM','10:00 AM','10:30 AM',
  '11:00 AM','11:30 AM','12:00 PM','12:30 PM',
  '1:00 PM','1:30 PM','2:00 PM','2:30 PM',
  '3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM',
];

// City coords for map
export const CITY_COORDS = {
  'Melbourne': [-37.8136, 144.9631],
  'Sydney':    [-33.8688, 151.2093],
  'Brisbane':  [-27.4705, 153.0260],
  'Perth':     [-31.9505, 115.8605],
  'Adelaide':  [-34.9285, 138.6007],
  'Canberra':  [-35.2809, 149.1300],
  'Gold Coast':[-28.0167, 153.4000],
  'Wollongong':[-34.4244, 150.8939],
  'Darwin':    [-12.4634, 130.8456],
  'Hobart':    [-42.8821, 147.3272],
  'default':   [-37.8136, 144.9631],
};
